import {
  createStyles,
  HoverCard,
  HoverCardProps,
  Stack,
  Text,
} from '@mantine/core';
import React, { ReactNode } from 'react';

import { InvoiceItem } from '@portals/types';

import { ProductImage } from '../../ProductImage';

interface InvoiceItemTooltipPreviewProps {
  item: InvoiceItem;
  children: ReactNode;
}

export function InvoiceItemPreviewTooltip({
  item,
  children,
}: InvoiceItemTooltipPreviewProps) {
  const { classes } = useStyles();

  return (
    <HoverCard withinPortal position="bottom" openDelay={250}>
      <HoverCard.Target>{children}</HoverCard.Target>

      <HoverCard.Dropdown maw={275} styles={hoverCardStyles}>
        <Stack spacing="xs" align="center">
          <ProductImage
            src={item.product_image_url}
            width={86}
            className={classes.imageWrapper}
          />

          <Text size="md" color="gray.9">
            {item.product_name}
          </Text>

          <Text color="gray.5">{item.device_model_name}</Text>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

const hoverCardStyles: HoverCardProps['styles'] = (theme) => ({
  dropdown: {
    borderRadius: theme.radius.md,
    padding: theme.spacing.xxl,
  },
});

const useStyles = createStyles((theme) => ({
  imageWrapper: {
    overflow: 'hidden',
    border: `1px solid ${theme.colors.gray[1]}`,
    borderRadius: theme.radius.lg,
    marginBottom: theme.spacing.xs,
  },
}));
